import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";

let theme = createTheme({
  palette: {
    primary: {
      main: "#45A247",
    },
    secondary: {
      main: "#EFD154",
    },
    limegreen: {
      main: "#59DE5C",
    },
    grey: {
      main: "#565656",
      contrastColor: "#ffffff",
      dark: "#2d2d2d",
    },
    lightgrey: {
      main: "#eeeeee",
      dark: "#bcbcbc",
    },
    purple: {
      main: "#B218A7",
    },
    orange: {
      main: "#FE7B54",
      light: "#ffac82",
    },
    yellow: {
      main: "#ffcd00",
    },
    btnwhite: {
      main: "#ffffff",
    },
    background: {
      default: "#f9f9f9",
    },
  },
});

theme = createTheme({
  ...theme,
  direction: "rtl",
  typography: {
    fontSize: 16,
    fontFamily: [
      "zain",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          boxShadow: "none",
          // borderRadius: "3rem",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingLeft: "0px",
          paddingRight: "0px",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

const cache = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export function ThemeProviderRtl({ children }) {
  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
}
export default theme;
